import { differenceInMilliseconds, startOfDay } from 'date-fns';

// We always get dates looking like DD/MM/YYYY
export const convertFrenchDateToEnglishDate = (frenchDate: string): string => {
  const [day, month, year] = frenchDate.split('/');
  return `${month}/${day}/${year}`;
};

export type TimeLeftUnits = 'days' | 'hours' | 'minutes';
export type TimeLeft = Record<TimeLeftUnits, number>;

const DAY_DURATION = 1000 * 60 * 60 * 24;
const HOUR_DURATION = 1000 * 60 * 60;
const MINUTE_DURATION = 1000 * 60;

export const getTimeLeft = (target: Date): TimeLeft => {
  const targetDate = startOfDay(target);
  const difference = differenceInMilliseconds(targetDate, new Date());

  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0 };
  }

  return {
    days: Math.floor(difference / DAY_DURATION),
    hours: Math.floor((difference / HOUR_DURATION) % 24),
    minutes: Math.floor((difference / MINUTE_DURATION) % 60),
  };
};
